import { Banner } from '@apis/index'
import {
  deletesvg,
  edit,
  outlinenotification,
  switchOff,
  switchOn,
} from '@assets/icons'
import Svg from '@components/svg'
import Table from '@components/table'
import Wrapper from '@components/wrapper'
import useScrollToTop from '@hooks/useScrollToTop'
import { RootState } from '@store/index'
import theme from '@utils/theme'
import React, { Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const BannerList = () => {
  const scrollToTop = useScrollToTop()

  const navigate = useNavigate()
  const { data: banners, loading } = useSelector(
    (state: RootState) => state.banners,
  )

  const fetchBanners = async () => {
    try {
      await Banner.list({ state: 'banners' })
    } catch (error) {}
  }
  const columns = [
    {
      title: 'SN',
      key: 'sn',
      render: (_, i) => <p>{i}</p>,
    },
    {
      title: 'Banner Image',
      key: 'image',
      render: (item) => (
        <img
          src={`https://admin.tournaop.com/${item.image}`}
          alt="notification"
          width={100}
        />
      ),
    },
    {
      title: 'Redirect Link',
      key: 'link',
      render: (item) => (
        <p
          onClick={() => window.open(item.link, '_blank')}
          style={{ color: theme.colors.primary, cursor: 'pointer' }}
        >
          {item.link}
        </p>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Svg
          src={item.status ? switchOn : switchOff}
          onClick={async () =>
            await Banner.update({
              id: item.id,
              state: 'banners',
              data: { status: !item.status },
            })
          }
        />
      ),
    },
  ]

  const data = banners.map((b) => ({
    id: b.id,
    image: b.image,
    link: b.link,
    status: b.status,
  }))

  useEffect(() => {
    fetchBanners()
  }, [])

  return (
    <Fragment>
      <Wrapper>
        <Table
          loading={loading}
          searchKeys={['link']}
          text="Banner List"
          icon={outlinenotification}
          columns={columns}
          data={data}
          actions={[
            {
              icon: edit,
              key: 'edit',
              onClick: (item) => {
                navigate(`/admin/banner-settings/${item.id}`, { state: item })
                scrollToTop()
              },
            },
            {
              icon: deletesvg,
              key: 'remove',
              onClick: async (item) =>
                await Banner.remove({ state: 'banners', id: item.id }),
            },
          ]}
        />
      </Wrapper>
    </Fragment>
  )
}

export default BannerList
